export default {
    NONE: 'none',
    DOT: 'dot',
    ICON: 'icon',
    NUMBER: 'number',
};
